<template>
  <div v-if="stock_take_order">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip top v-if="showView && $permission.permissionAllow('StockTakes', 'view')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/stock-takes/detail/' + stock_take_order.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("StockTakes.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 盘点 -->
      <v-tooltip top v-if="showStockTake && $permission.permissionAllow('StockTakes', 'stockTake')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            @click.stop="checkActions()"
          >
            {{ $t("StockTakes.actions.stockTake") }}
          </v-btn>
        </template>
        <span>{{ $t("StockTakes.actions.stockTake") }}</span>
      </v-tooltip>
      <!-- 作废 -->
      <v-tooltip top v-if="showCancel && $permission.permissionAllow('StockTakes', 'cancel')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("StockTakes.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("StockTakes.actions.cancelStockStakeOrder") }}</span>
      </v-tooltip>
      <v-tooltip v-if="showExport && $permission.permissionAllow('StockTakes', 'detailExport')" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click="stockTakeOrdersExport()"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("StockTakes.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("StockTakes.actions.export") }}</span>
      </v-tooltip>
      <v-tooltip v-if="showHistoryExport" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click="stockTakeCurrentHistoryExport()"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("StockTakes.actions.historyExport") }}
          </v-btn>
        </template>
        <span>{{ $t("StockTakes.actions.export") }}</span>
      </v-tooltip>
    </v-sheet>

    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('StockTakes.ObjectName')"
      :code="stock_take_order.stock_take_code"
      @confirm="doAction('cancel')"
    />
  </div>
</template>

<script>
import DialogDelete from "@/components/plugins/DialogDelete";
import StockTakeOrders from "@/api/stock_takes";
import Shops from "@/api/shops";
import i18n from "@/i18n";
export default {
  name: "StockTakeOrderActions",

  components: {
    DialogDelete,
  },

  props: {
    stock_take_order: Object,
    detailMode: Boolean,
    showView: Boolean,
    showStockTake: Boolean,
    showCancel: Boolean,
    showExport: Boolean,
    showHistoryExport: Boolean,
  },

  data: () => ({
    printBtnMenu: false,
    exportBtnMenu: false,
    cancelAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "cancel")
        return StockTakeOrders.cancel(this.stock_take_order.id);
    },
    doAction(mode) {
      this.actionMethod(mode).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$emit("done");
            this.$router.push("/stock-takes");
          }
        }.bind(this)
      );
    },
    doPrint() {
      // this.$permission.checkAccountExpired().then(
      //   function () {
      //     //console.log(mode);
      //     // TODO print
      //   }.bind(this)
      // );
    },
    stockTakeOrdersExport() {
      StockTakeOrders.detailExport(this.stock_take_order.id);
    },
    stockTakeCurrentHistoryExport() {
      StockTakeOrders.stockTakeCurrentHistoryExport(this.stock_take_order.id);
    },
    checkActions() {
      Shops.checkAction(3).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.data.actions) {
              this.detailMode
                ? this.$emit("stockTake")
                : this.$router.push(
                    "/stock-takes/detail/" + this.stock_take_order.id + "/stockTake"
                  );
            } else {
              this.$snackbar.error(i18n.t(response.data.data.msg));
            }
          }
        }.bind(this)
      );
    },
  },
};
</script>